<template>
  <ElButton
    :loading="loading"
    type="primary"
    class="sf-query-submit"
    @click="search"
    >{{ buttonText || '筛选' }}</ElButton
  >
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ElButton } from 'element-plus';
import { useShareData } from '../../core/SharedData';

export default defineComponent({
  extends: [ElButton],

  props: {
    buttonText: { type: String, default: '' } // 按钮文本
  },

  setup() {
    const submit = useShareData('search', 'submit');
    const loading = useShareData('search', 'loading');

    //const pagination = useShareData('search', 'pagination') as Pagination;

    //const loading = ref(false);
    async function search() {
      // 显示loading
      //loading.value = true;
      //try {
      await submit();
      //}
      //finally {
      //	loading.value = false;
      //}
    }

    return { search, loading };
  }
});
</script>

<style lang="scss" scoped>
.sf-query-submit {
  width: 58px;
  height: 34px;
}
</style>
